// export const API_LOCATION = 'http://localhost:3336';
export const VERSION_DATE = '2022-6-17';
export const API_LOCATION = 'https://api.deltabase.org.uk';
// export const API_LOCATION_OCCAMS = 'http://localhost:3337';
